export const useAssets = () => {
    const getImage = (name, dir = null) => {
        return `/images/${dir ? `${dir}/` : ''}${name}`
    }

    return { getImage }
}
